<template>
<div>
  <list-table
    :url="cards.url"
    title="لیست شباها"
    :fields="cards.fields"
    :params="cards.params"
    :detailCallFun="cards.detailCallFun"
    :detailCallFunType="cards.detailCallFunType"
    @handle_function_call="ShowDetail"
  ></list-table>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
export default {
  name: "confirmAccounts",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      cards: {
        detailCallFunType: "id",
        detailCallFun: "ShowDetail",
        url: "unconfirmedcards",
        fields: [
          {
            key: "nickname",
            label: "نام صاحب حساب",
          },
          {
            key: "user.name",
            label: "نام ثبت کننده",
          },
          {
            key: "bank_name.title",
            label: "بانک",
          },
          {
            key: "status",
            label: "وضعیت",
            formatter(value, key, item) {
              return value.title;
            },
            tdClass(value, key, item) {
              switch (value.id) {
                case 1571:
                  return "text-success";
                case 1522:
                  return "text-warning";
                default:
                  return "text-danger";
              }
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
           {
            label: "نام",
            field: "nickname",
            type: "text",
          },
           {
            label: "کد ملی",
            field: "national_card_number",
            type: "text",
          },
           {
            label: "شماره شبا",
            field: "shaba_number",
            type: "text",
          },
        ],
      },
    };
  },
  methods: {
    ShowDetail(item, type) {
      this.$router.push("confirmSheba/" + item.id);
    },
  },
   mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست شباها" }]);
  }
};
</script>